<script setup lang="ts">
import type { NuxtLinkProps } from '#app'
import { NuxtLink } from '#components'
import type { ButtonHTMLAttributes } from 'vue'

withDefaults(
  defineProps<{
    to?: NuxtLinkProps['to']
    class?: ButtonHTMLAttributes['class']
    variant?: 'default' | 'primary' | 'subtle' | 'outline'
    size?: 'default' | 'sm' | 'lg'
  }>(),
  {
    variant: 'default',
    size: 'default',
  }
)
</script>

<template>
  <component
    :is="to ? NuxtLink : 'button'"
    :to
    :class="
      cn(
        'rounded-full font-kyiv font-medium inline-flex items-center transition-colors duration-150 justify-center disabled:opacity-50 whitespace-nowrap',
        {
          'bg-secondary hover:bg-secondary-dark text-white':
            variant === 'default',
          'bg-primary hover:bg-primary-dark text-white': variant === 'primary',
          'border border-secondary hover:border-primary text-secondary hover:text-primary':
            variant === 'subtle',
          'bg-transparent border border-[currentColor] text-inherit hover:bg-white/50 hover:text-primary':
            variant === 'outline',

          'px-4 py-2 gap-2': size === 'default',
          'px-2 py-1 text-sm gap-1': size === 'sm',
          'px-20 py-2.5 text-lg gap-3': size === 'lg',
        },
        $props.class
      )
    "
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>
